import React from 'react';
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom';
// import Breadcrumbs from '../Components/banner/New-banner';
import Create from '../Components/Phonenumber';
function Createlogin (){
    return(
        <>
        <Combaintop/>
        {/* <Breadcrumbs/> */}
        <Create/>

        <Combainbottom/>
        </>
    );

}

export default Createlogin;